export const resolveProjectTypesEnum = {
	real_estate_site_selection: "Real Estate Site Selection",
	colo_customer_search: "Colo Customer Search",
	business_development: "Business Development",
	sales_prospecting: "Sales Prospecting",
	custom_project: "Custom Project"
};

export const realEstateSitesSelectionTypesEnum = {
	new_market: "New Market",
	expansion: "Expansion"
};

export const resolveConstant = "Site Selector";

export const projectsConstant = "Projects";

export const dateFormat = "DD/MM/YYYY";
